import * as React from 'react';
import LogoPic from "../Assets/Images/logo.png";
import API from "../Services/API";
import EmptyPic from "../Assets/Images/emptypic.png";

export default function Header() {

    const [user, setUser] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        API.getUserInfo()
            .then((response) => {
                setUser(response.data.user);
                setIsLoaded(true)
            })
            .catch((error) => {

            });


    }, []);
    return (
        <React.Fragment>
            <header id="header" className="header fixed-top d-flex align-items-center  rtl">

                <div className="d-flex align-items-center justify-content-between">
                    <a href="https://www.ngkh.ir/" rel="noreferrer" target="_blank" className="logo d-flex align-items-center">
                        <img src={LogoPic} alt="Logo" className='not-show-mobile' />
                        <span className="d-none d-lg-block mx-2 text-small-2">NGKH</span>
                        <span className=' d-none d-lg-block   text-small-3 text-muted opacity-75'>
                            سامانه نگهبانی
                        </span>
                    </a>
                    <i className="bi bi-list toggle-sidebar-btn"
                    onClick={() =>{
                        document.getElementsByTagName('body')[0].classList.toggle('toggle-sidebar')
                    }}

                    ></i>
                </div>
                <nav className="header-nav position-absolute left-0 ">
                    <ul className="d-flex align-items-center">



                        <li className="nav-item dropdown pe-3">

                            <span className="nav-link nav-profile d-flex align-items-center pe-0" role='button' data-bs-toggle="dropdown" title={user.name
                                + ' ' + user.surname}>
                                <img  src={user.avatar  ? user.avatar : EmptyPic } alt="Profile" className="rounded-circle" />
                                <span className="d-none d-md-block dropdown-toggle ps-2 mx-2 text-small-2">

                                </span>
                            </span>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile ">
                                <li className="dropdown-header text-small-2">
                                    <h6 className='text-big-2'>
                                        {isLoaded && user?.vendor[0]?.title}

                                    </h6>

                                    <div className='my-2'>
                                        {user.name}
                                        &nbsp;

                                        {user.surname}
                                    </div>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <span className="dropdown-item d-flex text-small-2 align-items-center" >
                                        <i className="bi bi-person mx-2"></i>
                                        <span>ویرایش پروفایل</span>
                                    </span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <span className="dropdown-item d-flex align-items-center text-small-2" >
                                        <i className="bi bi-question-circle mx-2"></i>
                                        <span>راهنمای سامانه</span>
                                    </span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <span className="dropdown-item text-danger d-flex align-items-center text-small-2"
                                       onClick={onExitClick} role='button'
                                    >
                                        <i className="bi bi-box-arrow-right mx-2"></i>
                                        <span>خروج از سامانه</span>
                                    </span>
                                </li>

                            </ul>
                        </li>

                    </ul>
                </nav>


            </header>
        </React.Fragment>
    );
};